import { ChangeDetectionStrategy, Component, inject, OnInit } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { client } from '@kspl-franco/client.gen';
import { AppService } from '@shared/services/app.service';
import { LoadingOverlayComponent } from '@shared/ui/loading-overlay/loading-overlay';
import { environment } from 'environments/environment';
import { AuthService } from './services/auth.service';
import { ErrorService } from './services/error.service';
import { LoadingService } from './shared/services/loading.service';

@Component({
  selector: 'app-root',
  imports: [RouterOutlet, LoadingOverlayComponent],
  templateUrl: './app.html',
  styleUrl: './app.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppComponent implements OnInit {
  title = 'frontend';

  private readonly authService = inject(AuthService);
  private readonly errorService = inject(ErrorService);
  private readonly loadingService = inject(LoadingService);
  private readonly appService = inject(AppService);

  ngOnInit(): void {
    // Check authentication status on app initialization
    this.authService.checkAuthStatus();

    client.setConfig({
      baseUrl: environment.apiUrl,
    });

    client.interceptors.request.use(async request => {
      this.loadingService.show();
      return request;
    });

    client.interceptors.response.use(async response => {
      this.loadingService.hide();
      return response;
    });

    client.interceptors.error.use(async (error, response) => {
      this.loadingService.hide();
      this.errorService.handleHttpError(error, response);
    });

    this.appService.loadAppSettings();
  }
}
